<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div style="min-height: 100px">
      <div class="w-full relative" v-if="getpiclist.length">
        <Carousel
          :arrow="setting.arrow"
          :autoplay="setting.autoplay"
          :autoplay-speed="setting.autoplaySpeed"
          :dots="setting.dots"
          :radius-dot="setting.radiusDot"
          :trigger="setting.trigger"
          @on-change="changeImg"
          v-bind:height="getCarouselHeight"
          v-model="imgIndex">
          <CarouselItem :key="index" class="w-full h-full" v-for="(item,index) in getpiclist">
            <div class="demo-carousel w-full h-full relative">
              <img :src="item.imgUrl" alt="" class="w-full" style="min-height: 100%">
              <!--<video :src="item.url" class="w-full h-full"-->
              <!--style="object-fit: fill" v-if="item.fileType === 2"></video>-->
              <div class="absolute top-0 left-0 flex a-center j-center w-full h-full" style="background: #00000040"
                   v-if="item.fileType === 2">
                <img src="../../../assets/common/ic_shipin_play.png" style="width: 50px;height: 50px;">
              </div>
            </div>
          </CarouselItem>
        </Carousel>
        <div class="absolute text-center lh-24"
             style="width: 54px;height: 24px;background: rgba(0, 0, 0, 0.3);border-radius: 24px;right: 11px;bottom: 10px">
          <span class="fs-14" style="color: #FFFFFF">{{ imgNum }}/{{ iteminfo.config.coverList.length }}</span>
        </div>
      </div>

      <!--无商品图默认展示-->
      <div class="w-full relative bg-white p-b-2" v-if="!getpiclist.length">
        <div class="flex a-center j-center" style="height: 220px;background: #F8F8F9;">
          <div class="flex a-center flex-column">
            <img alt="" src="../../../assets/source/ic_img.png" style="width: 54px;height: 54px">
            <span class="fs-14 d-block m-t-4 color-999">上传图片/视频</span>
          </div>
        </div>
        <div class="absolute text-center lh-24"
             style="width: 54px;height: 24px;background: rgba(0, 0, 0, 0.3);border-radius: 24px;right: 11px;bottom: 10px">
          <span class="w-6 h-10 bg-white d-inline-block"></span>
          <span class="fs-14 m-h-4" style="color: #FFFFFF">/</span>
          <span class="w-6 h-10 bg-white d-inline-block"></span>
        </div>
      </div>
    </div>
    <div class="bg-white p-v-10 b-radius-4 m-h-5 m-v-10">
      <div class="m-v-2 m-h-4 text-nowrap" style="color: #FF6348" v-if="iteminfo.config.price">
        <span class="fs-18">￥{{ iteminfo.config.price }}</span>
      </div>
      <div class="m-h-8 fs-14 color-333" style="word-break: break-all" v-if="iteminfo.config.title">
        {{ iteminfo.config.title }}
      </div>
      <div class="m-h-8 fs-14" style="background: #F8F8F9;height: 48px;" v-if="!iteminfo.config.title">

      </div>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'

export default {
  name: 'ProductInfoWidget',
  components: {BaseDisplayWidget},
  props: {
    iteminfo: {
      type: Object,
      default: () => {
        return {
          config: {
            datalist: [],
            coverList: [],
            price: '',
            title: '',
            specification: '',
            classify: '',
            grouping: '',
            menuList: []
          }
        }
      }
    }
  },
  data () {
    return {
      imgIndex: 0,
      imgNum: 1,
      setting: {
        autoplay: false,
        autoplaySpeed: 2000,
        dots: 'none',
        radiusDot: false,
        trigger: 'click',
        arrow: 'hover'
      },
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    getpiclist () {
      if (this.iteminfo.config.coverList) {
        return this.iteminfo.config.coverList
      } else {
        return []
      }
    },
    getCarouselHeight () {
      let defaultHeight = 220
      if (this.iteminfo.config.coverList) {
        let width = this.iteminfo.config.coverList[0].width || 370
        let height = this.iteminfo.config.coverList[0].height || 220
        defaultHeight = height / width * 370
      }
      return defaultHeight
    }
  },
  methods: {
    init () {

    },
    changeImg () {
      this.$nextTick(() => {
        this.imgNum = this.imgIndex + 1
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
